import { Nullable, ProjectStatus, UserRole } from '@symfa-inc/providence-types';

export const canUserEditByProjectStatusAndRoles = (
  projectStatus: Nullable<ProjectStatus>,
  roles?: UserRole[],
) =>
  (projectStatus && projectStatus !== ProjectStatus.Hold) ||
  roles?.includes(UserRole.Accounting) ||
  roles?.includes(UserRole.EngineeringManager);
